import React from "react";
import { WebPConverter } from "../../components";
import PageStructure from "../page-structure/PageStructure";

const WebPConverterPage = () => {
  return (
    <div className="page-container">
      <PageStructure>
        <WebPConverter />
      </PageStructure>
    </div>
  );
};

export default WebPConverterPage;
